enum languages {
    'en' = 0,
    'fr' = 1,
    'de' = 2,
    'it' = 3
}

export default languages;



// WEBPACK FOOTER //
// ./src/enum/language.enum.ts